import { Component,  } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-unavailable-teams-modal',
  templateUrl: './unavailable-teams-modal.component.html',
  styleUrls: ['./unavailable-teams-modal.component.scss']
})
export class UnavailableTeamsModalComponent {

  constructor(
    protected dialogRef: NbDialogRef<UnavailableTeamsModalComponent>
  ) { }

  cancel(): void {
    this.dialogRef.close();
  }

}
